import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import CoinTracker from "./CoinTracker";
import Login from './Login.js';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { isMobile } from 'react-device-detect';

export default function Content(props) {
  const auth = getAuth();
  const [user, setUser] = useState(auth.currentUser);
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        setUser(user)
        // ...
      } else {
        // User is signed out
        // ...
      }
    });
  }, [auth])
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        minHeight: "70vh",
        alignItems: "center",
        justifyContent: "center",
        marginTop: '2rem',
        marginBottom: '2rem',
        "& > :not(style)": {
          m: 1,
          width: isMobile ? "70%" : '90%',
          minHeight: "80%",
          padding : '2rem'
        },
      }}
    >
      <Paper elevation={3}>
        {
          user ? <CoinTracker /> : <Login />
        }
      </Paper>
    </Box>
  );
}
